import React, { useState, useCallback, useEffect } from 'react'
import { Controlled as ControlledZoom } from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import { Toast } from 'antd-mobile'

import Camera from '../../camera'
import PreviewOperationDlg from '../../previewOperationDlg'
import { EnumFileType } from '../../data'
import { commitSpecialPic, delImage } from '@/service/open'
import {
  getImgServerUrl,
} from '../../util/urlCreator'
import Dialog from '@/components/dialog'

import DelSVG from '@/static/images/del.svg'
import ZoomSVG from '@/static/images/zoom.svg'
import './center.css'


/**
 * 改流程，提交图片前要截取4个点辅助去裁剪图片，原处理方式暂留   20210507
 * 算法暂时不提供接口了，此为对接 GO 服务开发的接口，名义上是临时使用等待算法端接口 20210421
 * 需要处理的图片展示 含 身份证明正反面、原驾驶证、暂住证、体检表     TODO：注意在此补充处理的类型
 * 上传的照片要经过各种加工，所以需要获取到 fileId 服务器查询
 * 这里统筹文件并上传
 * 整体有四层 1. 灰色背景  2. 触发开启相机的透明遮罩 3. 背景取景框  4. 根据拍照次数和类型决定的背景图  4. 相机图片
 */
function OperationCameraByGoNew(props: Picture.UploadFile): JSX.Element {
  console.log('reload OperationCameraByGo', props)
  const { defaultImg, text, type, steps, submitUrl, studentId, title, unionId, itemImgChange } = props
  const [img, setImg] = useState(defaultImg)
  const [fileId, setFileId] = useState(props.fileId)
  const [isZoomed, setIsZoomed] = useState(false)


  // 预览弹窗的接收变量，用于关闭弹窗
  let dlgPre = null

  const handleZoomChange = useCallback(shouldZoom => {
    setIsZoomed(shouldZoom)
  }, [])

  useEffect(() => { // change &
    if (fileId) {
      loadImg(fileId)
    }
    return () => {
      console.log('image change and dlg close', dlgPre)
      dlgPre && dlgPre.close()
    }
  }, [img])

  // 加载图片
  const loadImg = (fileId: string) => {
    const src = getImgServerUrl(fileId);
    setFileId(fileId)
    setImg(src)
    itemImgChange(type, fileId)
  }

  // 删除图片按钮
  const deleteImag = () => {
    delImage({
      fileType: type,
      studentId,
      unionId
    }).then(() => {
      // 注意时序
      setFileId('')
      setImg(defaultImg)
      itemImgChange(type, '')
    })
  }

  // 查看图片按钮
  const imgZoom = () => {
    setIsZoomed(true)
  }

  // 构造背景
  const cameraList = () => {
    const _zoom = {
      isZoomed: isZoomed,
      onZoomChange: handleZoomChange,
      overlayBgColorStart: 'rgba(0, 0, 0, 0)',
      overlayBgColorEnd: 'rgba(0, 0, 0, 0.5)',
    }

    return img !== null ?
      <ControlledZoom {..._zoom}><img className="center-img" src={img} key={img} alt={text} /></ControlledZoom> : null
  }

  // 选择拍照还是签字的图片, 不是拍照就是签字, 当被填充了真实文件时，不可见
  const renderFlag = () => {
    return fileId ? null : <div className="camera-flag" />
  }

  // 改流程20210507，提交图片前要截取4个点辅助去裁剪图片，原处理方式暂留
  // 提交图片，接口和数据格式不统一，粗口!! 身份证明正反面、原驾驶证、暂住证、体检表 调算法
  const commitImg = (imgBase64) => {
    commitSpecialPic({
      studentId,
      fileType: type,
      base64: imgBase64,
      unionId
    }).then(res => {
      Toast.success(`上传${title}成功`, 2, () => {
        loadImg(res.data)
        dlgPre && dlgPre.close()
      })
    })
  }


  const inputFileChange = (file: File, stepArr) => {
    if (!file) {
      Toast.fail('图片文件不能为空！')
      return
    }

    // setImg(filestr)
    dlgPre = openDlg({
      type,
      studentId,
      file: file,
      // n次拍摄时显示的标题, 子组件依赖此判断步骤次数
      steps: stepArr,
      fileIndex: 0,  // 图片索引，多次拍摄时，确定更新的位置, 0 开始
      submitUrl: submitUrl,  // 上传地址
      // submitBefore?: () => {},
      // submitAfter?: () => {},
      // onSave: (imgList?: File[]) => {
      onSave: commitImg    // 拍摄完成
    })
  }

  const renderCamera = () => {
    if (fileId) {
      return null
    }
    const cameraProps = {
      className: '',
      changeCallback: (file) => inputFileChange(file, steps),
    }
    return <Camera {...cameraProps} />
  }

  const openDlg = (params) => {
    return Dialog(<PreviewOperationDlg {...params} />)
  }

  // 构造处理区域, 按钮组等
  const renderOperArea = () => {
    const operBtns = [
      <a key="zoom" className="oper-btn oper-zoom" onClick={() => imgZoom()}><img className="oper-img" src={ZoomSVG} alt="放大" /><span className="oper-txt">放大</span></a>,
      <a key="del" className="oper-btn oper-del" onClick={() => deleteImag()}><img className="oper-img" src={DelSVG} alt="删除" /><span className="oper-txt">删除</span></a>
    ]
    if (fileId) {
      return operBtns
    } else if (type === EnumFileType.暂住证) {
      const casters = ['拍摄暂住证正面', '拍摄暂住证反面', '保存']
      const cameraProps = {
        className: '',
        changeCallback: (file) => inputFileChange(file, casters),
      }
      return <a className="oper-btn oper-zoom"><Camera {...cameraProps} /><span className="oper-txt">双面拍摄</span></a>
    } else {
      return null
    }
  }

  return (
    <>
      <div className="imgload-bg">
        <div className="flex-center">
          <div className="block">
            {cameraList()}
            {renderFlag()}
          </div>
          {!fileId ? <span className="bg-txt">{text}</span> : null}
        </div>
        {renderCamera()}
      </div>
      <div className="oper-area">
        {renderOperArea()}
      </div>
    </>
  )
}

export default OperationCameraByGoNew
